import { useMemo } from "react";
import { useResource } from "@rest-hooks/core";
import { ProfileResource, LoginResource } from "@ploy-lib/rest-resources";
export function useTasks(tasks = [], placeholder) {
    const profile = useResource(ProfileResource.detail(), !placeholder && tasks.some(t => t.filter.salepersonId === "current")
        ? {}
        : null);
    const login = useResource(LoginResource.status(), !placeholder && tasks.some(t => t.filter.vendorId === "current") ? {} : null);
    return useMemo(() => {
        return tasks.map(task => ({
            ...task,
            filter: {
                ...task.filter,
                salepersonId: task.filter.salepersonId === "current"
                    ? profile?.salespersonId
                    : task.filter.salepersonId,
                vendorId: task.filter.vendorId === "current"
                    ? login?.vendor?.id
                    : task.filter.vendorId
            }
        }));
    }, [login, profile, tasks]);
}
//# sourceMappingURL=useTasks.js.map